// Hand-drawn arrow with imperfect lines
export function SketchArrow({
  direction = 'right', // 'right', 'left', 'down', 'up'
  color = 'rgba(255, 226, 188, 0.5)', // default to cream/gold
  className = '',
  size = 'sm' // 'sm', 'md'
}) {
  const sizeMap = {
    sm: { width: 40, height: 20 },
    md: { width: 60, height: 30 }
  };

  const { width, height } = sizeMap[size];

  const rotationMap = {
    right: 0,
    down: 90,
    left: 180,
    up: 270
  };

  const rotation = rotationMap[direction];

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 20"
      fill="none"
      className={className}
      style={{ transform: `rotate(${rotation}deg)` }}
    >
      {/* Arrow shaft - slightly wobbly */}
      <path
        d="M 2 10 Q 12 9.5 20 10.2 Q 28 10 35 10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      {/* Arrow head - imperfect */}
      <path
        d="M 30 5 L 38 10.5 L 30.5 15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
